import * as React from "react";
import PropTypes from "prop-types";
import i18n from "../../i18n";

const icons = {
  Pause: require('./audio-pause.svg'),
  Play: require('./audio-play.svg'),
  Microphone: require('./microphone.svg'),
  MicrophoneWhite: require('./microphone-white.svg'),
  AudioBg: require('./audio-bg.svg'),
  SocGoogle: require('./soc-google.svg'),
  SocFacebook: require('./soc-facebook.svg'),
  SocEmail: require('./soc-email.svg'),
  Eye: require('./eye.svg'),
  EyeWhite: require('./eye-white.svg'),
  CounterEye: require('./counter-eye.svg'),
  DefaultAvatar: require('./default-avatar.svg'),
  DefaultSettingsAvatar: require('./settings-default-avatar.svg'),
  LogoWhite: require('./logo-white.svg'),
  LogoDark: require('./logo-dark.svg'),
  LogoPurple: require('./logo-purple.svg'),
  HeaderBackDark: require('./header-back-dark.svg'),
  HeaderBackWhite: require('./header-back-white.svg'),
  HeaderBackDarkBlue: require('./header-back-dark-blue.svg'),
  FormatVideoOutline: require('./format-video-outline.svg'),
  FormatAudioOutline: require('./format-audio-outline.svg'),
  FormatImageOutline: require('./format-image-outline.svg'),
  FormatUploadOutline: require('./format-upload-outline.svg'),
  FormatVideoOutlineGray: require('./format-video-outline--gray.svg'),
  FormatAudioOutlineGray: require('./format-audio-outline--gray.svg'),
  FormatImageOutlineGray: require('./format-image-outline--gray.svg'),
  FormatUploadOutlineGray: require('./format-upload-outline--gray.svg'),
  FormatVideoOutlineDark: require('./format-video-outline--dark.svg'),
  FormatAudioOutlineDark: require('./format-audio-outline--dark.svg'),
  FormatImageOutlineDark: require('./format-image-outline--dark.svg'),
  FormatUploadOutlineDark: require('./format-upload-outline--dark.svg'),
  MediaClose: require('./media-close.svg'),
  MediaCloseDark: require('./media-close-dark.svg'),
  ModalClose: require('./modal-close.svg'),
  ModalBack: require('./modal-back.svg'),
  Smile: require('./smile.svg'),
  CheckedTheme: require('./checked-theme.svg'),
  ModalCloseSmall: require('./modal-close-small.svg'),
  ModalCloseDark: require('./modal-close-dark.svg'),
  ModalCloseSmallDark: require('./modal-close-small-dark.svg'),
  InputError: require('./input-error.svg'),
  BreadcrumbsVideoIcon: require('./breadcrumbs-video.svg'),
  CloseSidebar: require('./close-sidebar.svg'),
  CloseSidebarDark: require('./close-sidebar-dark.svg'),
  Logout: require('./logout.svg'),
  Login: require('./login.svg'),
  Arrow: require('./arrow.svg'),
  HamburgerDark: require('./hamburger-dark.svg'),
  HamburgerLight: require('./hamburger-light.svg'),
  EditPencil: require('./edit-pencil.svg'),
  EditPencilBrand: require('./edit-pencil-brand.svg'),
  EditPencilDark: require('./edit-pencil-dark.svg'),
  Trash: require('./trash.svg'),
  TrashBlack: require('./trash-black.svg'),
  CheckedBlack: require('./checked-black.svg'),
  MemorialCandle: require('./memorial-candle.svg'),
  Expand: require('./expand.svg'),
};

class Icon extends React.PureComponent {

  static propTypes = {
    allowRTL: PropTypes.bool
  };

  static defaultProps = {
    allowRTL: false
  };

  render() {
    const isRtl = i18n.dir() === 'rtl';
    const { name, allowRTL, style, ...other } = this.props;
    const src = icons[name];
    if (allowRTL && isRtl) {
      const divStyles = { ...(style || {}), transform: 'rotate(180deg)' };
      return (
        <div {...other} style={divStyles}>
          <img src={src} {...other} style={style} />
        </div>
      )
    }
    return (
      <img src={src} {...other} style={style} />
    )
  }
}

export default Icon;
